module.exports = __webpack_public_path__ + "img/patients_how-sign-up_4.86bee0dc.png";